module.exports = __webpack_public_path__ + "img/undraw_absorbed_in_xahs.a2310762.svg";